import { SimpleCandleBreakIndicator } from '../../../../components/displays/newTradingInterface/tradingModule/components/chart/chartElements/tacticLines/SimpleCandleBreakIndicator';
import { CandleBreakTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/entries/CandleBreakTacticPanel';
import { CandleBreakWrapper } from '../../../../components/displays/tradeplans/softOrderModules/entryTacticModules/CandleBreakModule/wrapper/CandleBreakWrapper';
import CandleBreakDocs from '../../../../components/forms/tradeplans/documentation/CandleBreakDocumentation';
import CandleBreakModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/entryTactics/modules/CandleBreakModule';
import { CandleBreakData } from './candleBreakData';
import { validateCandleBreak } from './validateCandleBreak';




export const CandleBreak = {
  //data class
  dataStore: CandleBreakData,

  //string constants
  name: 'CANDLE_BREAK',
  tacticLabel: 'Candle Break',
  addTacticLabel: 'Add Candle Break',
  category: 'Entry',

  // components
  tradePlanFormModule: CandleBreakModule,
  tacticPanel: CandleBreakTacticPanel,
  addTacticPanel: null,
  wrapper: CandleBreakWrapper,
  chartSoftOrderComponent: null,
  documentation: CandleBreakDocs,
  alertDetailsComponent: null,
  simpleChartComponent: SimpleCandleBreakIndicator,

  //functions
  setupDetailParser: null, //todo
  validationFunction: validateCandleBreak,
};
